<div class="container">
    <h1 class="text-center">Relatório de acessos ao PremoCenter</h1>
    <form [formGroup]="formulario" class="mt-4">
        <div class="col">
            <div class="d-flex flex-row row">
                <div class="col-sm-12 col-md-6 pb-3">
                    <label for="dataInicial" class="form-label w-100">
                        Data inicial:
                        <input type="datetime-local" class="form-control mt-1 date" id="dataInicial"
                            formControlName="dataInicial">
                    </label>
                </div>
                <div class="col-sm-12 col-md-6 pb-3 d-flex flex-column">
                    <label for="dataFinal" class="form-label w-100">
                        Data final:
                        <input type="datetime-local" class="form-control mt-1 date" id="dataFinal"
                            formControlName="dataFinal">
                    </label>
                    <div class="text-break text-danger" *ngIf="formularioTemErroData()">
                        A data final deve ser maior que a data inicial.
                    </div>
                </div>
            </div>
            <div class="col-md-12 pb-3 px-0">
                <label for="idClientes" class="form-label w-100">
                    Clientes:
                    <mat-select class="input form-control" multiple [(ngModel)]="clientesSelecionados"
                        formControlName="idsClientes" [disabled]="clientes.length == 0">
                        <mat-option *ngIf="clientes.length == 0">Nenhum cliente encontrado</mat-option>
                        <mat-option value="0" #opcaoTodosClientes
                            (click)="selecionarTodosClientes(opcaoTodosClientes)">Todos os
                            clientes</mat-option>
                        <mat-option [value]="cliente.sr_id" *ngFor="let cliente of clientes"
                            (click)="selecionarCliente(cliente.sr_id)">{{cliente.vc_nome}}</mat-option>
                    </mat-select>
                </label>
            </div>
        </div>
    </form>
    <div class="d-flex justify-content-center mt-2">
        <div class="pr-2">
            <button class="btn-sucesso btn btn-md btn-success" [disabled]="clientes.length == 0 || formulario.invalid"
                (click)="baixarRelatorio()">
                Baixar relatório
            </button>
        </div>
        <div class="pr-2">
            <button id="btn-fechar" class="btn btn-link pr-2" (click)="fecharDialog()">Fechar</button>
        </div>
    </div>
</div>